<div class="liberro-contact-detail">
  <div class="contact-content">
    <div class="contact-label">{{ label }}</div>
    <div class="contact-value">
      @if (type === 'email') {
        <a [href]="'mailto:' + value">{{ value }}</a>
      }
      @if (type === 'phone') {
        <a [href]="'tel:' + value">{{ value }}</a>
      }
      @if (type === 'text') {
        <span>{{ value }}</span>
      }
    </div>
  </div>
  <div class="contact-icon">
    <svg-icon [src]="icon" svgClass="contact-icon-svg"></svg-icon>
  </div>
</div>
